export default __webpack_public_path__ + "static/media/benefit_2.af24bed5.svg";